import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a002d6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lms-lesson" }
const _hoisted_2 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "completed-screen"
}
const _hoisted_6 = { class: "completed-card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "completed-screen__icon" }, "✓", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lektion abgeschlossen!", -1))
const _hoisted_9 = { class: "completed-actions" }
const _hoisted_10 = {
  key: 2,
  class: "player-wrapper"
}
const _hoisted_11 = { class: "lesson-bar" }
const _hoisted_12 = { class: "lesson-bar__inner" }
const _hoisted_13 = { class: "lesson-bar__title" }
const _hoisted_14 = {
  class: "iframe-container",
  ref: "iframeContainer"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "loading-screen"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "no-scorm"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Für diese Lektion ist noch kein SCORM-Paket hinterlegt.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.lesson && !_ctx.isFallback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.isCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("p", null, [
                _createTextVNode(" Sie haben "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.lesson ? _ctx.lesson.title : _ctx.module && _ctx.module.title), 1),
                _createTextVNode(" erfolgreich abgeschlossen. ")
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn-outline-action",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restartLesson && _ctx.restartLesson(...args)))
                }, " Nochmals ansehen "),
                _createElementVNode("button", {
                  class: "btn-primary-action",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                }, " Zurück zur Kursübersicht ")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "lesson-bar__back",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                }, "← Kursübersicht"),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.lesson ? _ctx.lesson.title : (_ctx.module && _ctx.module.title)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.scormPath && _ctx.ready)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    src: _ctx.scormPath,
                    frameborder: "0",
                    allow: "autoplay; fullscreen",
                    class: "course-iframe",
                    onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args))),
                    ref: "courseIframe"
                  }, null, 40, _hoisted_15))
                : (_ctx.scormPath)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("button", {
                        class: "btn-outline-action",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                      }, "Zurück zur Kursübersicht")
                    ]))
            ], 512)
          ]))
  ]))
}